<div class="po-type-form">
    <h6 class="form-section-title">Job Cost</h6>
    <div class="row">
        <div class="col-sm-3 col-6 form-group">
            <label for="jmJcCo">JC Co</label>
            <input type="number" class="form-control" [(ngModel)]="item().jcCo" name="jmJcCo" id="jmJcCo" />
        </div>
        <div class="col-sm-5 col-6 form-group">
            <label for="jmJob">Job</label>
            <input type="text" class="form-control" [(ngModel)]="item().job" name="jmJob" id="jmJob" />
        </div>
        <div class="col-sm-4 col-12 form-group">
            <label for="jmPhase">Phase</label>
            <input type="text" class="form-control" [(ngModel)]="item().phase" name="jmPhase" id="jmPhase" />
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3 col-6 form-group">
            <label for="jmCostType">CT</label>
            <input type="number" class="form-control" [(ngModel)]="item().costType" name="jmCostType" id="jmCostType" />
        </div>
    </div>

    <h6 class="form-section-title mt-3">Material</h6>
    <div class="row">
        <div class="col-sm-4 col-6 form-group">
            <label for="jmMaterial">Material</label>
            <input type="text" class="form-control" [(ngModel)]="item().material" name="jmMaterial" id="jmMaterial" />
        </div>
        <div class="col-sm-4 col-6 form-group">
            <label for="jmVendorMat">Vendor Mat</label>
            <input type="text" class="form-control" [(ngModel)]="item().vendorMaterial" name="jmVendorMat" id="jmVendorMat" />
        </div>
        <div class="col-sm-2 col-6 form-group d-flex align-items-end">
            <div class="form-check">
                <input type="checkbox" class="form-check-input" [(ngModel)]="item().receiving" name="jmReceiving" id="jmReceiving" />
                <label class="form-check-label" for="jmReceiving">Receiving</label>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-4 col-6 form-group">
            <label for="jmTicket">Ticket</label>
            <input type="text" class="form-control" [(ngModel)]="item().ticket" name="jmTicket" id="jmTicket" />
        </div>
    </div>

    <app-po-common-fields [item]="item()" [glAccountReadonly]="true"></app-po-common-fields>
</div>
